import { Typography } from "@mui/material";

/**
 * Exibe um texto simples dentro de um formulário.
 */
export default function TextOutput({ sx, children, ...props }) {
    return (
        <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", grow: 1, pb: "4px", ...sx }} {...props}>
            {children}
        </Typography>
    );
}
